import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { useSectionAnimationContext } from '../contexts/SectionAnimationContext';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { showSection, toggleSection } = useSectionAnimationContext();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'About Gideon', href: '#personal', id: 'personal' },
    { name: 'Tech Projects', href: '#projects', id: 'projects' },
    { name: 'Blog & Insights', href: '#blog', id: 'blog' },
    { name: 'Contact', href: '#contact', id: 'contact' }
  ];

  const scrollToSection = (sectionId) => {
    // Check if we're on the homepage
    const currentPath = window.location.pathname;
    
    if (currentPath === '/') {
      // We're on homepage, use existing animation logic
      showSection(sectionId);
      
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // We're on a different page, navigate to homepage with section
      window.location.href = `/#${sectionId}`;
    }
    
    setIsMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 liquid-glass-nav ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <button 
            onClick={() => window.location.href = '/'}
            className="text-2xl font-bold text-brand-primary font-grotesk hover:opacity-80 transition-opacity"
          >
            GM
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="nav-link text-text-primary hover:text-brand-hover transition-colors duration-300"
              >
                {item.name === 'About Gideon' ? (
                  <>About <span className="text-red-600">Gideon</span></>
                ) : (
                  item.name
                )}
              </button>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-text-primary"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-border-light pt-4">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="block w-full text-left py-2 text-text-primary hover:text-brand-hover transition-colors duration-300"
              >
                {item.name === 'About Gideon' ? (
                  <>About <span className="text-red-600">Gideon</span></>
                ) : (
                  item.name
                )}
              </button>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;